"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupControllerLifeCycleCallbacks = void 0;
var tslib_1 = require("tslib");
var bernie_core_1 = require("bernie-core");
var convert_request_1 = require("./convert-request");
var queryString = require("query-string");
var bernie_logger_1 = require("bernie-logger");
var location_reactor_1 = require("./location-reactor");
var getRequest = function (appData, controller, baseUrl, location) {
    if (baseUrl === void 0) { baseUrl = ''; }
    if (location === void 0) { location = window.location; }
    return (0, convert_request_1.convertRequest)(appData, (0, bernie_core_1.matchRoute)([controller], location.pathname, { baseUrl: baseUrl }), queryString.parse(location.search));
};
var setupControllerLifeCycleCallbacks = function (appData, baseUrl, storeContainer, controller, logger) {
    var callback = function (_a) { return tslib_1.__awaiter(void 0, [_a], void 0, function (_b) {
        var result, prevQuery, prevParams, error_1;
        var prev = _b.prev, next = _b.next;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    prevQuery = (prev && prev.query) || {};
                    prevParams = (prev && prev.params) || {};
                    return [4 /*yield*/, controller.fetch({
                            query: (next && tslib_1.__assign(tslib_1.__assign({}, next.query), { prevQuery: prevQuery })) || {},
                            params: (next && tslib_1.__assign(tslib_1.__assign({}, next.params), { prevParams: prevParams })) || {},
                            request: getRequest(appData, controller, baseUrl),
                            logger: logger,
                            stores: storeContainer,
                        }, {
                            data: new bernie_core_1.Data(appData.context, appData.experimentContextStore, storeContainer),
                            logger: logger,
                        })];
                case 1:
                    result = _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    logger.logEvent(new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'CONTROLLER_FETCH_ERROR'), error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, result];
            }
        });
    }); };
    var deactivate = function (hocLocation) {
        if (controller.willDeactivate && typeof controller.willDeactivate === 'function') {
            try {
                controller.willDeactivate({
                    query: hocLocation && hocLocation.query,
                    params: hocLocation && hocLocation.params,
                    request: getRequest(appData, controller, baseUrl, hocLocation),
                    logger: logger,
                    stores: storeContainer,
                }, {
                    data: new bernie_core_1.Data(appData.context, appData.experimentContextStore, storeContainer),
                    logger: logger,
                });
            }
            catch (error) {
                logger.logEvent(new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.WARN, 'CONTROLLER_DEACTIVATE_ERROR'), error);
            }
        }
    };
    controller.component = (0, location_reactor_1.withLocationReactor)(controller.component, callback, deactivate);
    return controller;
};
exports.setupControllerLifeCycleCallbacks = setupControllerLifeCycleCallbacks;
//# sourceMappingURL=controller-life-cycle.js.map